// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1naUP","label":"Labeled_label__1_O2b","divider":"Labeled_divider__1IUaY"};